import { FOOTER_MJML } from "../common/footer";
import { MARKETING_HEADER } from "../common/header";

export const newsletter = `
<mjml>
  <mj-head>
    <mj-title>Monthly Newsletter</mj-title>
    <mj-preview>The latest updates from our team</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${MARKETING_HEADER("Monthly Newsletter", "October 2023")}
    
    <mj-section background-color="#ffffff" padding="20px 0">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Thank you for subscribing to our newsletter. Here are the latest updates from our team.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 20px 0">
      <mj-column>
        <mj-image src="https://via.placeholder.com/600x300" alt="Feature Image" />
        <mj-text font-size="24px" color="#333333" font-family="Arial, sans-serif" font-weight="bold">Featured Article</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin euismod blandit pharetra. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Curabitur non nulla sit amet nisl tempus convallis.</mj-text>
        <mj-button background-color="#007bff" color="#ffffff" font-family="Arial, sans-serif" href="#" border-radius="4px">Read More</mj-button>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px">
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x200" alt="Article 1" />
        <mj-text font-size="20px" color="#333333" font-weight="bold">Company News</mj-text>
        <mj-text font-size="16px" color="#555555">Stay updated with the latest happenings at our company.</mj-text>
        <mj-button background-color="#6c757d" color="#ffffff" href="#" border-radius="4px">Read More</mj-button>
      </mj-column>
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x200" alt="Article 2" />
        <mj-text font-size="20px" color="#333333" font-weight="bold">Industry Insights</mj-text>
        <mj-text font-size="16px" color="#555555">Explore the latest trends and developments in the industry.</mj-text>
        <mj-button background-color="#6c757d" color="#ffffff" href="#" border-radius="4px">Read More</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "newsletter",
  name: "Monthly Newsletter",
  category: "marketing",
  description:
    "A professional newsletter template with multiple content sections, perfect for monthly updates, company news, and featured articles.",
  features: [
    "Header with logo",
    "Featured article section",
    "Two-column layout for additional content",
    "Social media footer",
    "Mobile responsive",
  ],
  subject: "Monthly Newsletter",
  subTitle: "The latest updates from our team",
  mjmlTemplate: newsletter,
};
